import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/slice";
import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find-index";
import _Object$assign from "@babel/runtime-corejs3/core-js/object/assign";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/values";
import _Map from "@babel/runtime-corejs3/core-js/map";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapActions } from "vuex";
import AvatarTooltip from "@Shared/components/general/avatar-tooltip";
import { LOAD_BOARD_COLLABORATORS } from "@Broker/@Modules/clients/board/store/board-actions";
import { BOARDS, COLLABORATORS } from "@Broker/@Modules/clients/board/store/board-getters";
import vSelectField from "@Shared/components/form-elements/fields/v-select-field.vue";
import materialInput from "@Shared/components/inputs/material-input.vue";
import { cloneDeep } from "lodash";
import { defineComponent } from "@vue/composition-api";
import { fullName } from "@Shared/@Utils/helpers/text";
export default defineComponent({
  name: "AssigneeSelect",
  components: {
    vSelectField,
    AvatarTooltip,
    materialInput
  },
  props: {
    assignees: {
      type: Array,
      default: () => []
    },
    inlineEdit: {
      type: Boolean,
      default: false
    },
    board: {
      type: [String, Number],
      default: ""
    },
    clientProfileId: {
      type: [String, Number],
      default: ""
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    keepEditing: {
      type: Boolean,
      default: false
    },
    avatarContainerClass: {
      type: String,
      default: "mt-3"
    },
    preloadCollaborators: {
      type: Boolean,
      default: true
    },
    multiple: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      default: ""
    },
    hiddenLabel: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ""
    },
    timeLineItemCard: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      editing: false,
      labelId: "",
      defaultValue: []
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters("BoardStore", [BOARDS, COLLABORATORS, "getDefaultAssignees", "getDetails"])), {}, {
    collaborators() {
      return this.COLLABORATORS(this.boardId);
    }
  }, mapState("BoardStore", {
    boardOwner(state) {
      const clientBoard = state.boards && state.boards.byId[this.boardId];
      const boardOwner = clientBoard && clientBoard.ownerDetails || {};
      return boardOwner;
    },
    boardId(state) {
      if (this.board) {
        return this.board;
      }
      const [statusLabel = {}] = state.clientProfiles.byId[this.clientProfileId].statusLabels || [];
      return statusLabel.boardId || "";
    }
  })), {}, {
    assigneesValues() {
      var _context, _context2;
      return _filterInstanceProperty(_context = _mapInstanceProperty(_context2 = this.assignees).call(_context2, assigneeUsername => {
        var _context3;
        const collaborator = this.collaborators && this.collaborators[assigneeUsername];
        if (collaborator) return collaborator;
        const boardOwner = this.boardOwner && this.boardOwner.username === assigneeUsername;
        if (boardOwner) return this.boardOwner;
        return _findInstanceProperty(_context3 = this.collaboratorsWithDefaults).call(_context3, ({
          username
        }) => username === assigneeUsername);
      })).call(_context, Boolean);
    },
    assigneesSelected() {
      var _context4;
      return _mapInstanceProperty(_context4 = this.assigneesValues).call(_context4, assignee => {
        return _objectSpread({
          label: fullName(assignee),
          fullName: fullName(assignee)
        }, assignee);
      });
    },
    firstThreeAssignees() {
      var _context5;
      return _sliceInstanceProperty(_context5 = this.assigneesValues).call(_context5, 0, 3);
    },
    isEditing() {
      return this.editing;
    },
    vSelectCollaboratorsOptions() {
      var _context6;
      const collabs = _mapInstanceProperty(_context6 = this.collaboratorsWithDefaults).call(_context6, collaborator => {
        return _objectSpread({
          label: fullName(collaborator),
          fullName: fullName(collaborator)
        }, collaborator);
      });
      return [...collabs];
    },
    collaboratorsWithDefaults() {
      var _allCollaborators$own, _context7;
      const allCollaborators = cloneDeep([..._Object$values(this.collaborators), ...this.defaultAssignees]);
      const ownersIndex = _findIndexInstanceProperty(allCollaborators).call(allCollaborators, assignee => assignee.username === this.boardOwner.username);
      if (ownersIndex > -1 && !((_allCollaborators$own = allCollaborators[ownersIndex]) != null && _allCollaborators$own.email)) {
        _Object$assign(allCollaborators[ownersIndex], {
          email: this.boardOwner.email
        });
      } else {
        allCollaborators.push(this.boardOwner);
      }
      return [..._valuesInstanceProperty(_context7 = new _Map(_mapInstanceProperty(allCollaborators).call(allCollaborators, item => [item.username, item]))).call(_context7)];
    },
    defaultAssignees() {
      var _context8;
      return _mapInstanceProperty(_context8 = this.getDefaultAssignees(this.clientProfileId)).call(_context8, assignee => {
        return _objectSpread({
          label: fullName(assignee),
          fullName: fullName(assignee)
        }, assignee);
      });
    },
    tooltipPlacement() {
      return this.inlineEdit ? "right" : "top";
    }
  }),
  watch: {
    board(val, oldVal) {
      this.LOAD_BOARD_COLLABORATORS({
        boardId: val
      });
      if (oldVal) {
        this.assigneesValues.forEach(assignee => this.handleChange(assignee, "unselect"));
      }
    }
  },
  async mounted() {
    if (!this.board) return;
    await this.LOAD_BOARD_COLLABORATORS({
      boardId: this.board
    });
  },
  methods: _objectSpread(_objectSpread({}, mapActions("BoardStore", [LOAD_BOARD_COLLABORATORS])), {}, {
    setEdit({
      edit,
      open = true
    }) {
      if (this.readOnly) return;
      this.editing = edit;
      if (!this.editing) return;
      if (open) {
        this.$refs.select.open();
      }
    },
    handleChange(data, type) {
      if (type === "clear") {
        this.$emit("change", type);
      }
      this.defaultValue = data;
      this.$emit("change", data, type);
    },
    handleClearAssignee() {
      this.defaultValue = [];
      this.$emit("change", [], "clear");
    }
  })
});